import { lazy } from "react"
import {
  APIARY_EVENT_VIEW,
  APIARY_EVENT_LIST_VIEW,
  NEW_APIARY_EVENT_VIEW,
} from "@/features/events/apiary-events/routes/route-list.ts"
import DesktopSidebarLayout from "@/layouts/desktop-sidebar-layout/desktop-sidebar-layout.tsx"
import NoMenuLayout from "@/layouts/no-menu-layout/no-menu-layout.tsx"

const AllApiaryEventsView = lazy(
  () =>
    import(
      "@/features/events/apiary-events/views/all-apiary-events-view/all-apiary-events-view.tsx"
    ),
)
const ApiaryEventView = lazy(
  () =>
    import(
      "@/features/events/apiary-events/views/apiary-event-view/apiary-event-view.tsx"
    ),
)
const NewApiaryEventView = lazy(
  () =>
    import(
      "@/features/events/apiary-events/views/new-apiary-event-view/new-apiary-event-view.tsx"
    ),
)

export const apiaryEventRoutes = [
  {
    path: NEW_APIARY_EVENT_VIEW,
    element: <NewApiaryEventView />,
  },
  {
    path: APIARY_EVENT_LIST_VIEW,
    element: <AllApiaryEventsView />,
  },
  {
    path: APIARY_EVENT_VIEW,
    element: <ApiaryEventView />,
  },
]

const DESKTOP_ROUTES = [
  {
    element: <DesktopSidebarLayout />,
    children: apiaryEventRoutes,
  },
]

export const MOBILE_APIARY_EVENT_ROUTES = [
  {
    element: <NoMenuLayout />,
    children: apiaryEventRoutes,
  },
]

export const getApiaryEventRoutes = (isDesktop: boolean) => {
  if (isDesktop) {
    return DESKTOP_ROUTES
  }
  return MOBILE_APIARY_EVENT_ROUTES
}
